import { Controller } from "@hotwired/stimulus";
import httpService from "../../../services/HttpService";
import { WebAuthnSigner } from "@dfns/sdk-browser";
import { storage } from "../../../storageconstants";
import { debugError, debugLog } from "../../../utils";
import { errorToastMessages, isUserCancellation, showErrorCard, showErrorToast } from "../../../errorsurfaces";

export default class extends Controller {
  static values = {
    chainid: String,
    checkoutid: String,
    session: String,
    spenderaddress: String,
    tokencontractaddress: String,
    approval: String,
    challenge: String,
    credentialType: String,
  }

  async connect() {
    this.hideLoadingScreen();
    this.attestation = null;
    this.domain = JSON.parse(sessionStorage.getItem(storage.DOMAIN));
    this.session = sessionStorage.getItem(storage.SESSION)
    this.challenge = JSON.parse(this.challengeValue);
    this.approval = JSON.parse(this.approvalValue);
  }

  async handleSignChallenge() {
    this.showLoadingScreen();

    try {
      if (!this.challenge) throw new Error("No challenge available to sign");
      if (!this.domain)    throw new Error("Domain data not available");

      if (this.credentialTypeValue === "key_credential") {
        debugLog("Using keycredential for signing");

        let signResonse = await httpService.post(`/sign/`, {
          challenge: this.challenge,
          session: this.session
        });

        if (signResonse.error) {
          this.hideLoadingScreen();
          debugError(signResonse.error);
          throw new Error(signResonse.error);
        }

        debugLog("KeyCredential signing successful:", signResonse.data);

        this.attestation = signResonse.data;
      } else {
        debugLog("Starting WebAuthn signing for stored challenge");

        const webauthn = new WebAuthnSigner({
          relyingParty: {
            id: this.domain.domain,
            name: this.domain.company,
          },
        });

        this.attestation = await webauthn.sign(this.challenge);
      }

      this.handleApproval();
    } catch (error) {
      debugLog("Error during WebAuthn signing:", error);
      this.hideLoadingScreen();
      if (isUserCancellation(error)) {
        showErrorToast(errorToastMessages.passkeyCancelled);
      } else {
        showErrorCard("signing-failed", { session: this.sessionValue });
      }
    }
  }

  async handleApproval() {
    const form = document.getElementById("frame-post-form");
    document.getElementById("form_challengeIdentifier").value = this.challenge.challengeIdentifier;
    document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
    document.getElementById("form_approvalData").value = JSON.stringify(this.approval);
    document.getElementById("form_tokenContractAddress").value = this.tokencontractaddressValue;
    document.getElementById("form_session").value = this.sessionValue;

    form.action = `/${sessionStorage.getItem(storage.CODE)}/authorized-wallet-review/`;
    form.requestSubmit();
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
